<div class="main-box">
  <div class="main-box-header">
    <ng-content select="[box][header]"></ng-content>
  </div>
  <div class="main-box-subheader">
    <ng-content select="[box][subheader]"></ng-content>
  </div>
  <div>
    <ng-content select="[box][content]"></ng-content>
  </div>
</div>

